// Written by scripts/make-common-passwords.mjs: run it again rather than editing this file.
//
// The UK National Cyber Security Centre's list of the 100,000 passwords most
// often found in breaches (NCSC, "Passwords, passwords everywhere", 2019),
// published under the Open Government Licence v3.0, as included in SecLists
// (https://github.com/danielmiessler/SecLists, MIT licence):
// Passwords/Common-Credentials/100k-most-used-passwords-NCSC.txt at commit 1a7bb9127eca9e6ff2fc0301c597fe6e16a0cb56, SHA-256 c2e5696882c603b76bb67a47ee970897e5a76fc4c3f5547abe3d0ca340c576e0.
// Its 1000 most common entries of at least 5 characters with a letter in them,
// lower-cased, without repeats, most common first. The server checks the whole list.

export const MOST_COMMON_PASSWORDS: readonly string[] = [
  "qwerty",
  "password",
  "abc123",
  "password1",
  "iloveyou",
  "1q2w3e4r5t",
  "qwertyuiop",
  "monkey",
  "dragon",
  "123456a",
  "1qaz2wsx",
  "myspace1",
  "homelesspa",
  "123qwe",
  "a123456",
  "123abc",
  "1q2w3e4r",
  "qwe123",
  "qwerty123",
  "target123",
  "tinkle",
  "qwerty1",
  "zxcvbnm",
  "1g2w3e4r",
  "gwerty",
  "zag12wsx",
  "gwerty123",
  "fuckyou",
  "asdfghjkl",
  "1q2w3e",
  "qazwsx",
  "computer",
  "princess",
  "12345a",
  "ashley",
  "michael",
  "football",
  "sunshine",
  "1234qwer",
  "iloveyou1",
  "aaaaaa",
  "fuckyou1",
  "daniel",
  "princess1",
  "asdfgh",
  "passer2009",
  "abcd1234",
  "shadow",
  "football1",
  "love123",
  "superman",
  "jordan23",
  "jessica",
  "monkey1",
  "12qwaszx",
  "a12345",
  "baseball",
  "123456789a",
  "killer",
  "samsung",
  "master",
  "azerty",
  "charlie",
  "asd123",
  "soccer",
  "fqrg7cs493",
  "jordan",
  "michael1",
  "jesus1",
  "linkedin",
  "babygirl1",
  "blink182",
  "thomas",
  "qwer1234",
  "liverpool",
  "michelle",
  "nicole",
  "qwert",
  "j38ifubn",
  "asdasd",
  "lovely",
  "q1w2e3r4",
  "gfhjkm",
  "andrew",
  "hello1",
  "joshua",
  "status",
  "justin",
  "anthony",
  "angel1",
  "iloveyou2",
  "zxcvbn",
  "hello",
  "jennifer",
  "hunter",
  "naruto",
  "bitch1",
  "welcome",
  "tigger",
  "babygirl",
  "jessica1",
  "parola",
  "robert",
  "fuckyou2",
  "loveme",
  "123456q",
  "apple",
  "pokemon",
  "mother",
  "money1",
  "secret",
  "anthony1",
  "purple",
  "q1w2e3r4t5y6",
  "baseball1",
  "qazwsxedc",
  "buster",
  "matthew",
  "andrea",
  "soccer1",
  "basketball",
  "hannah",
  "freedom",
  "golfer",
  "chelsea",
  "passw0rd",
  "george",
  "trustno1",
  "friends",
  "william",
  "iloveu",
  "amanda",
  "number1",
  "chocolate",
  "qwerty12",
  "summer",
  "flower",
  "charlie1",
  "maggie",
  "pakistan",
  "samantha",
  "asdf1234",
  "letmein",
  "asshole1",
  "superman1",
  "marina",
  "batman",
  "fuk19600",
  "butterfly",
  "qweqwe",
  "29rsavoy",
  "forever",
  "mustang",
  "sunshine1",
  "ashley1",
  "internet",
  "london",
  "harley",
  "alexander",
  "xbox360",
  "q1w2e3",
  "pepper",
  "family",
  "loveyou",
  "50cent",
  "joseph",
  "whatever",
  "jasmine",
  "orange",
  "junior",
  "cookie",
  "martin",
  "qweasdzxc",
  "1qazxsw2",
  "password12",
  "google",
  "password2",
  "lol123",
  "hello123",
  "jordan1",
  "shadow1",
  "patrick",
  "3rjs1la7qe",
  "ginger",
  "nicole1",
  "mylove",
  "arsenal",
  "abcdef",
  "love12",
  "vqsablpzla",
  "taylor",
  "myspace",
  "brandon",
  "angel",
  "12345q",
  "brandon1",
  "chris1",
  "diamond",
  "snoopy",
  "asshole",
  "qweasd",
  "starwars",
  "matrix",
  "mickey",
  "school",
  "jonathan",
  "melissa",
  "eminem",
  "cjmasterinf",
  "lovers",
  "nikita",
  "richard",
  "yellow",
  "12345qwert",
  "oliver",
  "q1w2e3r4t5",
  "cheese",
  "a123456789",
  "christian",
  "wall.e",
  "sophie",
  "tudelft",
  "diosesfiel",
  "dpbk1234",
  "pe#5gz29ptzmse",
  "bailey",
  "u38fa39",
  "mercedes",
  "victoria",
  "asdasd5",
  "matthew1",
  "abcdefg",
  "peanut",
  "red123",
  "happy1",
  "sandra",
  "benjamin",
  "dragon1",
  "elizabeth",
  "prince",
  "amanda1",
  "angels",
  "angela",
  "qqqqqq",
  "samuel",
  "banana",
  "barcelona",
  "ghbdtn",
  "computer1",
  "michelle1",
  "william1",
  "hockey",
  "monster",
  "carlos",
  "justin1",
  "antonio",
  "qwertyu",
  "nathan",
  "killer1",
  "chicken",
  "lucky1",
  "gabriel",
  "welcome1",
  "zaq12wsx",
  "jasmine1",
  "silver",
  "hunter1",
  "bubbles",
  "hottie1",
  "purple1",
  "andrew1",
  "daniel1",
  "liverpool1",
  "1qaz2wsx3edc",
  "rainbow",
  "morgan",
  "natasha",
  "fuckoff",
  "jackson",
  "austin",
  "vanessa",
  "mommy1",
  "madison",
  "adidas",
  "xxxxxx",
  "america",
  "james1",
  "metallica",
  "slipknot",
  "chicken1",
  "jesus",
  "alexis",
  "!ab#cd$",
  "spiderman",
  "steven",
  "ferrari",
  "lauren",
  "robert1",
  "qwaszx",
  "buddy1",
  "butterfly1",
  "tinkerbell",
  "bandit",
  "danielle",
  "nicholas",
  "hannah1",
  "qwerty12345",
  "asdfasdf",
  "pokemon1",
  "nirvana",
  "destiny",
  "scooter",
  "cookie1",
  "123qweasd",
  "loveme1",
  "chelsea1",
  "chocolate1",
  "1234567a",
  "juventus",
  "rachel",
  "111222tianya",
  "qazxsw",
  "zzzzzz",
  "monica",
  "stella",
  "america1",
  "jennifer1",
  "freedom1",
  "taylor1",
  "yamaha",
  "victor",
  "qwertyui",
  "a1b2c3",
  "ronaldo",
  "1password",
  "smokey",
  "david1",
  "money",
  "daddy1",
  "cocacola",
  "a838hfid",
  "1234abcd",
  "joshua1",
  "123asd",
  "buster1",
  "myspace123",
  "booboo",
  "madison1",
  "samantha1",
  "heather",
  "elizabeth1",
  "tigger1",
  "family1",
  "mustang1",
  "november",
  "jasper",
  "lovely1",
  "diamond1",
  "success",
  "edward",
  "music1",
  "valentina",
  "harley1",
  "sweety",
  "tennis",
  "zxc123",
  "friend",
  "qaz123",
  "whatever1",
  "thomas1",
  "nothing",
  "n0=acc3ss",
  "super123",
  "casper",
  "chester",
  "exigent",
  "password123",
  "cheese1",
  "spongebob1",
  "mynoob",
  "hahaha",
  "hellokitty",
  "alexandra",
  "canada",
  "david",
  "1q2w3e4r5t6y",
  "dennis",
  "december",
  "olivia",
  "a1b2c3d4",
  "playboy",
  "sabrina",
  "patricia",
  "summer1",
  "friends1",
  "mexico1",
  "dakota",
  "barbie",
  "loulou",
  "johnny",
  "music",
  "123456m",
  "lover1",
  "maggie1",
  "pretty",
  "123hfjdk147",
  "nicolas",
  "qwert1",
  "charles",
  "phoenix",
  "rebecca",
  "thunder",
  "sexy123",
  "iloveu2",
  "123456789q",
  "batman1",
  "beautiful",
  "carolina",
  "vincent",
  "jeremy",
  "spider",
  "master1",
  "heather1",
  "weed420",
  "sojdlg123aljg",
  "pepper1",
  "sebastian",
  "yankees",
  "dallas",
  "pussy1",
  "cameron",
  "caroline",
  "peanut1",
  "guitar",
  "startfinding",
  "midnight",
  "iw14fi9j",
  "yankees1",
  "elephant",
  "scorpion",
  "tweety",
  "bubbles1",
  "fuckoff1",
  "cowboys1",
  "fuckme",
  "fucker",
  "louise",
  "dolphin",
  "patrick1",
  "loser1",
  "mother1",
  "lalala",
  "naruto1",
  "veronica",
  "melissa1",
  "sparky",
  "newyork",
  "adrian",
  "123456s",
  "september",
  "heaven",
  "alexander1",
  "jessie",
  "crystal",
  "tigers",
  "iloveyou!",
  "chris",
  "gemini",
  "raiders1",
  "zxcvbnm1",
  "peaches",
  "merlin",
  "spongebob",
  "scooby",
  "stephanie",
  "shannon",
  "james",
  "1a2b3c",
  "sergey",
  "lovelove",
  "precious",
  "123456j",
  "lakers",
  "manchester",
  "ginger1",
  "cristina",
  "apples",
  "a1234567",
  "qqww1122",
  "pussy",
  "daniela",
  "jackson1",
  "123456b",
  "jackie",
  "rocky1",
  "asdfghjkl1",
  "sakura",
  "qazwsx123",
  "yellow1",
  "flower1",
  "apple1",
  "newyork1",
  "sammy1",
  "muffin",
  "cherry",
  "poohbear",
  "richard1",
  "nigger1",
  "test123",
  "destiny1",
  "flowers",
  "slipknot1",
  "cooper",
  "monster1",
  "baby123",
  "mexico",
  "blessed1",
  "toyota",
  "spiderman1",
  "beauty",
  "emmanuel",
  "genius",
  "winston",
  "tiffany",
  "charlotte",
  "iloveu1",
  "diablo",
  "onelove",
  "tiger1",
  "badboy",
  "maverick",
  "joseph1",
  "winner",
  "mickey1",
  "creative",
  "beautiful1",
  "softball",
  "hotmail",
  "421uiopy258",
  "brittany",
  "aa123456",
  "asdf123",
  "lastfm",
  "manuel",
  "sayang",
  "kristina",
  "austin1",
  "stupid1",
  "hottie",
  "booboo1",
  "murphy",
  "stalker",
  "carmen",
  "doudou",
  "qazqaz",
  "scorpio",
  "m123456",
  "pimpin1",
  "badoo",
  "garfield",
  "fuckme1",
  "scooter1",
  "aaaaa",
  "brandy",
  "kitty1",
  "myspace2",
  "steelers",
  "compaq",
  "claudia",
  "123456d",
  "rabbit",
  "bailey1",
  "crazy1",
  "august",
  "isabella",
  "orange1",
  "october",
  "q123456",
  "green1",
  "black1",
  "samson",
  "angelo",
  "1a2b3c4d",
  "boomer",
  "junior1",
  "12345678a",
  "shorty1",
  "tyler1",
  "kimberly",
  "guitar1",
  "cowboys",
  "shorty",
  "passion",
  "soleil",
  "christ",
  "1v7upjw3nt",
  "albert",
  "andrey",
  "ranger",
  "dexter",
  "lucky7",
  "popcorn",
  "babyboy1",
  "bitch",
  "alyssa",
  "brittany1",
  "123456abc",
  "forever1",
  "fucker1",
  "barney",
  "blessed",
  "metallica1",
  "karina",
  "krishna",
  "cameron1",
  "california",
  "christian1",
  "melanie",
  "j123456",
  "password!",
  "happy",
  "woaini",
  "danielle1",
  "samsung1",
  "gangsta1",
  "icecream",
  "letmein1",
  "qwerty123456",
  "eagles",
  "love13",
  "qwert123",
  "uqa9ebw445",
  "fucku2",
  "smokey1",
  "leonardo",
  "asdfgh1",
  "police",
  "christine",
  "windows",
  "bismillah",
  "miguel",
  "iloveyou12",
  "snickers",
  "arsenal1",
  "bubba1",
  "cowboy",
  "denise",
  "pretty1",
  "george1",
  "q12345",
  "winter",
  "dancer",
  "coffee",
  "player1",
  "fernando",
  "maxwell",
  "swordfish",
  "rangers",
  "horses",
  "francis",
  "martina",
  "fylhtq",
  "chivas1",
  "secret1",
  "s123456",
  "marlboro",
  "qwerty1234",
  "kitten",
  "lauren1",
  "twilight",
  "florida",
  "pass123",
  "yagjecc826",
  "jason1",
  "nathan1",
  "sydney",
  "pumpkin",
  "molly1",
  "dolphin1",
  "vfhbyf",
  "natalie",
  "hiphop",
  "skater1",
  "fishing",
  "bond007",
  "kobe24",
  "barbara",
  "loveyou1",
  "tiffany1",
  "john316",
  "cassie",
  "iloveme",
  "hardcore",
  "stupid",
  "fatima",
  "alexis1",
  "rockstar",
  "abc1234",
  "123456z",
  "playboy1",
  "123123a",
  "greenday",
  "maria",
  "angelina",
  "starwars1",
  "google1",
  "b123456",
  "school1",
  "bonnie",
  "123qwe123",
  "sz9kqcctwy",
  "lucky",
  "father",
  "courtney",
  "sexy12",
  "crystal1",
  "abc123456",
  "fluffy",
  "kissme",
  "marseille",
  "trinity",
  "sweet1",
  "candy1",
  "qwerty7",
  "password3",
  "alejandro",
  "pookie",
  "roberto",
  "sarah1",
  "player",
  "justinbieb",
  "turtle",
  "poohbear1",
  "simone",
  "corvette",
  "jackass1",
  "lolita",
  "jonathan1",
  "steven1",
  "alicia",
  "lollipop",
  "jackass",
  "123456c",
  "biteme",
  "honey",
  "motorola",
  "nicholas1",
  "friendster",
  "angel123",
  "portugal",
  "iloveme1",
  "simple",
  "vfrcbv",
  "brooklyn",
  "morgan1",
  "darkness",
  "rainbow1",
  "shelby",
  "slayer",
  "natalia",
  "snowball",
  "chicago",
  "aaaaaa1",
  "people",
  "lovers1",
  "sharon",
  "golden",
  "snoopy1",
  "shannon1",
  "raiders",
  "123qweasdzxc",
  "sweetie",
  "teresa",
  "blue123",
  "awesome",
  "boston",
  "victoria1",
  "pamela",
  "wilson",
  "ssssss",
  "kevin",
  "klaster",
  "123456k",
  "kenneth",
  "bonjour",
  "tucker",
  "catherine",
  "hockey1",
  "pa55word",
  "password.",
  "eminem1",
  "love11",
  "mnbvcxz",
  "logitech",
  "redsox",
  "remember",
  "popcorn1",
  "kevin1",
  "isabelle",
  "p3rat54797",
  "seven7",
  "steelers1",
  "marcus",
  "bulldog",
  "yfnfif",
  "cricket",
  "lakers24",
  "edward1",
  "tweety1",
  "qazwsx1",
  "123456t",
  "single",
  "lizottes",
  "nastya",
  "amber1",
  "sarah",
  "blessing",
  "marley",
  "rockstar1",
  "fender",
  "aaa111",
  "willow",
  "camille",
  "aaaaaaaa",
  "florida1",
  "peaches1",
  "bella1",
  "carlos1",
  "connor",
  "d123456",
  "love4ever",
  "cutie1",
  "indian",
  "goodluck",
  "marie1",
  "loveme2",
  "marine",
  "hammer",
  "chance",
  "stephen",
  "123456l",
  "z123456",
  "santiago",
  "strawberry",
  "abcdefg1",
  "bigdaddy",
  "daisy1",
  "thunder1",
  "asdfghjk",
  "marvin",
  "mmmmmm",
  "vanessa1",
  "happy123",
  "abcd123",
  "fuckyou!",
  "iverson3",
  "hotdog",
  "svetlana",
  "arthur",
  "never",
  "tintin",
  "iceman",
  "orlando",
  "satan666",
  "superstar",
  "babygurl1",
  "johnson",
  "fyfcnfcbz",
  "freddy",
  "rachel1",
  "magic",
  "qwert12345",
  "chester1",
  "loverboy",
  "miller",
  "cookies",
  "parker",
  "azertyuiop",
  "porsche",
  "teacher",
  "angelica",
  "yourmom1",
  "bullshit",
  "sunday",
  "christopher",
  "love1234",
  "travis",
  "evildick",
  "monika",
  "nissan",
  "asdfg",
  "midnight1",
  "williams",
  "please",
  "spencer",
  "aaaaa1",
  "gateway",
  "tiger",
  "dallas1",
  "111111a",
  "charles1",
  "gracie",
  "raymond",
  "ladybug",
  "sweetpea",
  "rush2112",
  "greenday1",
  "sunflower",
  "baby12",
  "jason",
  "precious1",
  "lakers1",
  "brooklyn1",
  "stephanie1",
  "undertaker",
  "12345t",
  "sweetheart",
  "ihateyou",
  "zachary",
  "emily1",
  "fktrcfylh",
  "tamara",
  "asdfjkl",
  "lebron23",
  "andrei",
  "paradise",
  "doctor",
  "kawasaki",
  "polniypizdec0211",
  "a12345678",
  "money123",
  "sophia",
  "winnie",
  "bianca",
  "bigboy",
  "qqq111",
  "jacob1",
  "andrea1",
  "julian",
  "pantera",
  "lucky13",
  "poopoo",
  "lollol",
  "3d8cubaj2e",
  "lorenzo",
  "sasuke",
  "babyboy",
  "nascar",
  "hahaha1",
  "vladimir",
  "abc12345",
  "sierra",
  "shopping",
  "career121",
  "12345qwerty",
  "genesis",
  "christina",
  "bandit1",
  "mylove1",
  "nelson",
  "january",
  "sweet",
  "qq123456",
  "scarface",
  "montana",
  "ricardo",
  "dolphins",
  "giovanni",
  "frankie",
  "soccer12",
  "johnny1",
  "facebook",
  "changeme",
  "zxcvbnm123",
  "jerome",
  "sassy1",
  "password11",
  "qw123321",
  "dakota1",
  "australia",
  "southside1",
  "soccer10",
  "zoosk",
  "maryjane",
  "brenda",
  "rebecca1",
  "baller1",
  "honey1",
  "jeffrey",
  "xavier",
  "eagles1",
  "getmoney1",
  "brianna1",
  "realmadrid",
  "scooby1",
  "westside",
  "minnie",
  "bobby1",
  "vampire",
  "linkinpark",
];
